/**
 * AIGL PWA service worker registration.
 * Registers /service-worker.js (served from public/) on production-style HTTPS contexts.
 * Localhost and HTTPS are supported; insecure HTTP is skipped automatically by the browser.
 */
export function registerServiceWorker() {
  if (typeof window === "undefined") return;
  if (!("serviceWorker" in navigator)) return;

  // Avoid double-registration during React 18 StrictMode dev double-renders.
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/service-worker.js", { scope: "/" })
      .then((reg) => {
        // Auto-activate updated SW when a new version is found.
        if (reg && reg.waiting) {
          reg.waiting.postMessage({ type: "SKIP_WAITING" });
        }
        reg.addEventListener("updatefound", () => {
          const nw = reg.installing;
          if (!nw) return;
          nw.addEventListener("statechange", () => {
            if (nw.state === "installed" && navigator.serviceWorker.controller) {
              nw.postMessage({ type: "SKIP_WAITING" });
            }
          });
        });
      })
      .catch((err) => {
        // Silently ignore - SW is a progressive enhancement.
        console.warn("[AIGL] Service worker registration failed:", err);
      });

    // Reload once the new SW takes control so users always see latest UI.
    let refreshing = false;
    navigator.serviceWorker.addEventListener("controllerchange", () => {
      if (refreshing) return;
      refreshing = true;
      window.location.reload();
    });
  });
}
